export default "__VITE_ASSET__BUAysk6F__"